import { EulerStateManager } from "../EulerStateManager";
import { BaseState } from "../States/BaseState";
import { EventData } from "../EventData";
class LoadAndShowOdds extends BaseState<EulerStateManager> {
  time: number = 0;
  public id = "LoadAndShowOdds";
  constructor(stateManager: EulerStateManager) {
    super(stateManager); // Pass the StateManager to the base class
  }

  public onEnter(stateManager: EulerStateManager): void {
    this.stateManager = stateManager; // Set the StateManager reference
    super.onEnter(stateManager); // Call the super method
    this.stateManager.onEnterLoadAndShowOddsState();

    this.handleCountdown();
  }

  private handleCountdown() {
    const eventData = EventData.getInstance();
    const expectedStartTime = eventData.getStartTime();

    if (expectedStartTime) {
      const interval = setInterval(() => {
        const now = new Date().getTime();
        let startTime = new Date(expectedStartTime).getTime() - 1000; //Transition a bit earlier to guarantee we dont get the "start" message in LoadAndShowOdds

        const timeDiff = startTime - now;
        this.time = Math.floor(timeDiff / 1000);

        if (this.time <= 0) {
          //onCountdownEnd();
          this.transition();
          clearInterval(interval);
        }
      }, 1000);
    }
  }

  private transition(): void {
    //Move to pre match suspend
    if (!this.stateManager) return;
    this.stateManager?.changeState(this.stateManager.eulerNoMoreBetsState);
  }

  public onExit(): void {
    super.onExit();
  }
}

export { LoadAndShowOdds };
